import React from 'react'
import { Box } from 'reactjs-admin-lte'
import { Button, Row, Col, FormGroup, FormControl, ControlLabel, ButtonToolbar } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import '../../report/report.css'
import moment from 'moment'
import Select from 'react-select'
import DatePicker from '../../../component/element/DatePicker'
import CkTimePicker from '../../../component/element/CkTimePicker'
import TextFieldModal from '../../../component/element/TextFieldModal'
import { momentHelper } from '../../../utils/helpers'
import WorkJobAssignTaskModal from './WorkJobAssignTaskModal'
import WorkdocStore from '../../../stores/WorkdocStore'
import JobControlBoardTable from './JobControlBoardTable'
import IframeModal from '../../../component/element/IframeModal'
import ConfirmPopup from 'component/element/ConfirmPopup'
import $ from 'jquery';
import {connect} from 'react-redux'
// import 'rc-time-picker/assets/index.css'
// import TimePicker from 'rc-time-picker'
// import { Form, FormControl, FormGroup, InputGroup, Glyphicon } from 'react-bootstrap'
var NotificationSystem = require('react-notification-system');

const mockData = {
  bf_task_id: '',
  taskName: '',
  taskValue: '',
  technicianName: '',
  startTime: {
    date: '',
    time: ''
  },
  finishTime: {
    date: '',
    time: ''
  },
  man_hour: '',
  man_hour_unit: '',
  duration: '',
  wageAmount: '',
  taskStatus: '-1',
  inspector: '',
  remark:'',
  assignTask: { person: { contractor_id: '', employee_id: '' }, leader: { employee_id: '' } }
}
// const jobList = ["รื้อ", "เคาะ", "โป๊ะ", "พื้น", "ผสมสี", "พ่น", "ประกอบ", "ขัดสี", "ล้าง", "QC"]
// const taskOptions = [{ label: 'รื้อ', value: 'dismanlingState' },
// { label: 'เคาะ', value: 'hitState' },
// { label: 'โป๊ว', value: 'trapState' },
// { label: 'พื้น', value: 'groundState' },
// { label: 'ผสมสี', value: 'mixColorState' },
// { label: 'พ่น', value: 'paintState' },
// { label: 'ประกอบ', value: 'assemblyState' },
// { label: 'ขัดสี', value: 'polishState' },
// { label: 'ล้าง', value: 'cleanState' },
// { label: 'QC', value: 'qcState' }]



class WorkJobTimeTable extends React.Component {
  constructor(props) {
    super(props)
    moment.locale('th')
    this.headerTitles = {
      taskName: this.props.messages['Task Name'],
      technicianName: this.props.messages['Technician'],
      startTime: this.props.messages['Start Time'],
      finishTime: this.props.messages['Finish Time'],
      duration: this.props.messages['Duration'],
      taskStatus: this.props.messages['Status (No Count Time)'],
      inspector: this.props.messages['Inspector'],
      remark :this.props.messages['Remark']
    }

    this.headerWidth = {
      startTime: ''
    }

    // const mockDataArr = taskOptions.map((item, index) => {
    //   let jsonObj = JSON.parse(JSON.stringify(mockData))
    //   jsonObj.taskName = item.label
    //   jsonObj.taskValue = item.value
    //   return jsonObj
    // })

    this.state = {
      showAssign: false,
      assignIndex: -1,
      _assignIndex: -1,
      data: [],
      loading: false,
      workData: null,
      remarkChanged: false,
      showTaskDelete: false
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    //this.loadData("SR304.0684/2560", null)
    $('body').on('click', ()=> { 
      if ($('.Select').hasClass('is-open'))
        $('.table-responsive').css( "overflow-x", "initial" );
      else
        $('.table-responsive').css( "overflow-x", "auto" );
    });
  }

  loadData(workNo,workData,workState) {
    // let { data } = this.state
    const newInitData = workState.map((item, index) => {
      let jsonObj = JSON.parse(JSON.stringify(mockData))
      jsonObj.taskName = item.label
      jsonObj.taskValue = item.value
      return jsonObj
    })
    this.setState({ workNo: workNo, loading: true, workData: workData, data: newInitData})
    WorkdocStore.loadWorkdocFixingTaskList(workNo,(result)=>{
      let rowData = []
      let checkTaskValue = []
      result.data.forEach((ritem, rindex)=>{ 
            let item = JSON.parse(JSON.stringify(mockData))
            let tasklist = ritem.tasklist[0]
            item.taskName = tasklist.taskName
            item.taskValue = tasklist.taskValue
            item.bf_task_id = ritem.bf_task_id
            item.taskStatus = tasklist.taskStatus
            item.technicianName = ritem.first_name + ' ' + ritem.last_name
            if (ritem.leader_first_name !== "")
              item.inspector = ritem.leader_first_name + ' ' + ritem.leader_last_name
            
            item.man_hour = ritem.man_hour
            item.man_hour_unit = ritem.man_hour_unit 
            item.wageAmount = ritem.total_cost
            item.startTime.date = momentHelper.convertWorldToThaiYear(tasklist.startDate)
            item.finishTime.date = momentHelper.convertWorldToThaiYear(tasklist.endDate)
            item.startTime.time = tasklist.startTime !== undefined ? tasklist.startTime : ''
            item.finishTime.time = tasklist.endTime !== undefined ? tasklist.endTime : ''
            item.duration = tasklist.duration
            item.assignTask.totalCost = ritem.total_cost
            item.remark = ritem.remark
            item.assignTask.person = { contractor_id: ritem.contractor_id, employee_id: ritem.employee_id, first_name: ritem.first_name, nick_name: ritem.nick_name, last_name: ritem.last_name }
            if (ritem.leader_first_name !== "")
              item.assignTask.leader = { employee_id: ritem.leader_id, first_name: ritem.leader_first_name, nick_name: ritem.leader_nick_name, last_name: ritem.leader_last_name }
            
            let key = checkTaskValue.indexOf(tasklist.taskValue)
            let checkWorkState = workState.findIndex(x => x.value==tasklist.taskValue)
            if (checkWorkState!=-1) {
              if (key!=-1) {
                if (Array.isArray(rowData[key])) {
                  rowData[key].push(item)
                } else {
                  let newInitData = []
                  newInitData.push(rowData[key])
                  newInitData.push(item)
                  rowData[key] = newInitData
                }
              } else {
                rowData.push(item)
                checkTaskValue.push(tasklist.taskValue)
              }
            }
      })
      let newResult = this.onSetInitData(rowData,checkTaskValue,workState)
      newResult.forEach((item,index)=>{
        if (Array.isArray(item)) {
          let checkStop = item.findIndex(x => x.taskStatus=='3')
          if (checkStop!=-1) {
            workData[item[item.length-1].taskValue] = '3'
          } else {
            let sumProcessValue = 0
            item.forEach((ritem,rindex)=>{
              let processValue = this.getProcessValue(ritem.taskStatus)
              sumProcessValue = sumProcessValue+processValue
            })
            if (sumProcessValue<=0) {
              let check1 = item.findIndex(x => x.taskStatus=='1.00')
              let check0 = item.findIndex(x => x.taskStatus=='0')
              if (check1!=-1) {
                workData[item[item.length-1].taskValue] = '1.00'
              } else if (check0!=-1) {
                workData[item[item.length-1].taskValue] = '0'
              }
            } else {
              let sumFloor = Math.floor(sumProcessValue/item.length)
              if (sumFloor>0&&sumFloor<10)
                sumFloor = sumFloor/100
              else if (sumFloor>=10&&sumFloor<100)
                sumFloor = (sumFloor/100)+1
              else if (sumFloor>=100)
                sumFloor = '2'
              
              sumFloor = sumFloor.toString()
              workData[item[item.length-1].taskValue] = sumFloor
            }
          }
        }
      })
      this.setState({ data: newResult, loading: false, workData: workData })
      this.refs.jcbTable.getWrappedInstance().loadData([workData],workState)
    },()=>{
      this.setState({ loading: false })
    })
  }

  onSetInitData(data,checkTaskValue,workState) {
    workState.forEach((titem,tindex)=>{
      let item = JSON.parse(JSON.stringify(mockData))
      item.taskName = titem.label
      item.taskValue = titem.value
      let newItem = checkTaskValue.indexOf(titem.value)
      if (newItem==-1)
        data.push(item)
    })
    
    let newResult = []
    workState.forEach((key)=>{
      data.forEach((item)=>{ 
          let taskValue = undefined
          if (Array.isArray(item))
            taskValue = item[item.length-1].taskValue
          else
            taskValue = item.taskValue
          if (taskValue == key.value)
            newResult.push(item)
      })
    })
    return newResult
  }

  onPrintClick() {
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintWorkJobTimeTable&wo='+this.state.workNo
    } else {
      url = './pdf/v2?startPage=PrintWorkJobTimeTable&wo='+this.state.workNo
    }  
    this.refs.iframePrint.loadUrl(url)
  }

  renderHeader() {
    if (typeof this.state.data === 'undefined') return null
    const ths = Object.keys(this.headerTitles).map((k, i) => (
      <th
        key={i + 1}
        className='fit text-center'
      >
        {this.headerTitles[k]}
      </th>
    ))

    return (
      <thead>
        <tr>{ths}</tr>
      </thead>
    )
  }

  onDateChange(k, rowIndex, _rowIndex, dateString, dateMoment) {
    let {data} = this.state
    const newData = [...this.state.data]
    if (Array.isArray(data[rowIndex])) {
      newData[rowIndex][_rowIndex][k].date = dateString
      //Calculate Duration
      newData[rowIndex][_rowIndex] = this.calculateDuration(newData[rowIndex][_rowIndex])
    } else {
      newData[rowIndex][k].date = dateString
      //Calculate Duration
      newData[rowIndex] = this.calculateDuration(newData[rowIndex])
    }  
    this.setState({
      data: newData
    })

    this.saveTask(rowIndex, newData, _rowIndex)
  }

  calculateDuration(itemData) {

    let finishTime = moment(itemData.finishTime.date, 'DD/MM/YYYY')
    let duration = moment.duration(finishTime.diff(moment(itemData.startTime.date, 'DD/MM/YYYY')));

    itemData.duration = duration.asDays() + 1;
    return itemData
  }

  renderDatePicker(rowIndex,value,k,taskStatus,_rowIndex) {
    return (
      <DatePicker style={{ display: 'inline-block', minWidth: '160px' }}
        disabled={taskStatus==='-2'}
        showIcon={true}
        showFooter={true}
        buddhistEra
        value={value}
        onChange={this.onDateChange.bind(this, k, rowIndex, _rowIndex)}
      />
    )
  }

  onTimeChange(k, index, _index, newValStr) {
    let {data} = this.state
    const newData = [...this.state.data]

    if (Array.isArray(data[index]))
      newData[index][_index][k].time = newValStr
    else
      newData[index][k].time = newValStr
    
    this.setState({
      data: newData
    })

    this.saveTask(index, newData, _index)
  }

  onTechnicianEdit(rowId,_rowId) {
    let { data } = this.state
    if (Array.isArray(data[rowId])) {
      this.setState({ showAssign: true, assignIndex: rowId, _assignIndex:_rowId })
      this.refs.taskModal.getWrappedInstance().loadTask({}, Object.assign({ bf_task_id: data[rowId][_rowId].bf_task_id }, data[rowId][_rowId].assignTask))
    } else {
      this.setState({ showAssign: true, assignIndex: rowId })
      this.refs.taskModal.getWrappedInstance().loadTask({}, Object.assign({ bf_task_id: data[rowId].bf_task_id }, data[rowId].assignTask))
    }  
  }

  onRowRemarkEdit(rowId,_rowId){
    let { data } = this.state
    let {messages} = this.props
    if (Array.isArray(data[rowId]))
      this.refs.rowRemarkModal.loadInfo({title:messages['Edit Remark'],showClear:true,rowId:rowId,_rowId:_rowId,value:data[rowId][_rowId].remark })
    else
      this.refs.rowRemarkModal.loadInfo({title:messages['Edit Remark'],showClear:true,rowId:rowId,value:data[rowId].remark })    
  }

  onRowRemarkSave(dataValue){
    let {data} = this.state
    let assignIndex = dataValue.rowId

    if (Array.isArray(data[assignIndex]))
      data[assignIndex][dataValue._rowId].remark = dataValue.value
    else
      data[assignIndex].remark = dataValue.value

    this.setState({ data: data })
    this.saveTask(assignIndex, data, dataValue._rowId)
  }

  getProcessValue(value) {
    let processValue = (value=='-2'||value=='-1'||value=='0'||value=='1.00'?0:value=='1.20'?20:value=='1.40'?40:value=='1.60'?60:value=='1.80'?80:value=='2'?100:0)
    return processValue
  }

  onSelectChange(rowId, _rowId, value) {
    let { data,workData } = this.state
    let {messages} = this.props
    let check_1 = -1
    let check_2 = -1
    if (Array.isArray(data[rowId])) {
      check_1 = data[rowId].findIndex(x => x.taskStatus=='-1')
      check_2 = data[rowId].findIndex(x => x.taskStatus=='-2')
      if ((data[rowId].length==2&&value.value=='-1'&&check_2!=-1)||(data[rowId].length==2&&value.value=='-2'&&check_1!=-1)) {
        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Unable to identify']+' "'+messages['No Item']+'" '+messages['Because More Than One'],
          level: 'error',
          position: 'tc'
        })
      } else {
        data[rowId][_rowId].taskStatus = value.value
        this.setState({ data: data, workData: workData })
        this.saveTask(rowId, data, _rowId)
      }
    } else {
      data[rowId].taskStatus = value.value
      this.setState({ data: data, workData: workData })
      this.saveTask(rowId, data, _rowId)
    }
  }

  onAssignTaskSave(jobData) {
    let { assignIndex, data, _assignIndex } = this.state
    if (Array.isArray(data[assignIndex])) {
      data[assignIndex][_assignIndex].assignTask = jobData
      if (jobData.person !== undefined && jobData.person !== null && jobData.person.first_name !== undefined && jobData.person.last_name !== undefined)
        data[assignIndex][_assignIndex].technicianName = jobData.person.first_name + ' ' + jobData.person.last_name
      
      if (jobData.leader !== undefined && jobData.leader !== null && jobData.leader.first_name !== undefined && jobData.leader.last_name !== undefined)
        data[assignIndex][_assignIndex].inspector = jobData.leader.first_name + ' ' + jobData.leader.last_name

      data[assignIndex][_assignIndex].wageAmount = jobData.totalCost
    } else {
      data[assignIndex].assignTask = jobData
      if (jobData.person !== undefined && jobData.person !== null && jobData.person.first_name !== undefined && jobData.person.last_name !== undefined)
        data[assignIndex].technicianName = jobData.person.first_name + ' ' + jobData.person.last_name

      if (jobData.leader !== undefined && jobData.leader !== null && jobData.leader.first_name !== undefined && jobData.leader.last_name !== undefined)
        data[assignIndex].inspector = jobData.leader.first_name + ' ' + jobData.leader.last_name

      data[assignIndex].wageAmount = jobData.totalCost
    }

    this.saveTask(assignIndex, data, _assignIndex)
    this.setState({ data: data, assignIndex: -1, _assignIndex: -1 })
  }

  onAssignTaskDelete() {
    let { assignIndex, _assignIndex } = this.state
    this.onDelTechnicianNameClick(assignIndex,_assignIndex)
  }

  onRemarkChange(e) {
    let { workData } = this.state
    workData.textState = e.target.value
    this.setState({ workData: workData, remarkChanged: true })
  }


  onRemarkBlur() {

  }

  onRemarkSave() {
    let { workNo, workData } = this.state
    this.saveWorkdocSummary(workNo, workData.textState)
  }

  saveWorkdocSummary(workNo, textState) {
    //Save
    let that = this
    let {messages} = this.props
    let postData = { wo: workNo, textState: textState }
    WorkdocStore.saveWorkdocSummary(postData, function (result) {


      that._notificationSystem.addNotification({
        title: messages['Notice'],
        message: messages['Successful Save Work'] + ' ' + workNo + ' ' + messages['Successful'],
        level: 'info',
        position: 'tc'
      });

    }, function () {
      that._notificationSystem.addNotification({
        title: messages['Notice'],
        message: messages['Failed Save Work'] + ' ' + workNo + ' ' + messages['Failed'],
        level: 'error',
        position: 'tc'
      });
    })


    this.setState({ remarkChanged: false })
  }

  onRemarkClear() {
    let { workData, workNo } = this.state
    workData.textState = ''
    this.setState({ workData: workData })

    this.saveWorkdocSummary(workNo, '')
  }

  onAfterSave(result,data,assignIndex,_assignIndex) {
    let { workNo } = this.state
    let {messages} = this.props
    if (Array.isArray(data[assignIndex])) {
      data[assignIndex][_assignIndex].bf_task_id = result.bf_task_id
      if (result.tasklist.length>0) {
        data[assignIndex][_assignIndex].man_hour = result.tasklist[0].man_hour
        data[assignIndex][_assignIndex].man_hour_unit = result.tasklist[0].man_hour_unit
      }  
    } else {
      data[assignIndex].bf_task_id = result.bf_task_id
      if (result.tasklist.length>0) {
        data[assignIndex].man_hour = result.tasklist[0].man_hour
        data[assignIndex].man_hour_unit = result.tasklist[0].man_hour_unit
      }
    }  

    this.setState({ data: data })
    this._notificationSystem.addNotification({
        title: messages['Notice'],
        message: messages['Successful Save Work'] + ' ' + workNo + ' ' + messages['Successful'],
        level: 'info',
        position: 'tc'
    });
    if (this.props.onStateChange !== undefined)
      this.props.onStateChange(workNo, result.taskstate)
    if (this.props.onReload !== undefined)
      this.props.onReload()  
  }

  updateWorkData(data,rowId,_rowId) {
    let {workData} = this.state
    let {workState} = this.props
    if (Array.isArray(data[rowId])) {
      let checkStop = data[rowId].findIndex(x => x.taskStatus=='3')
      if (checkStop!=-1) {
        workData[data[rowId][_rowId].taskValue] = '3'
      } else {
        let sumProcessValue = 0
        data[rowId].forEach((item,index)=>{
          let processValue = this.getProcessValue(item.taskStatus)
          sumProcessValue = sumProcessValue+processValue
        })
        if (sumProcessValue<=0) {
          let check1 = data[rowId].findIndex(x => x.taskStatus=='1.00')
          let check0 = data[rowId].findIndex(x => x.taskStatus=='0')
          if (check1!=-1) {
            workData[data[rowId][_rowId].taskValue] = '1.00'
          } else if (check0!=-1) {
            workData[data[rowId][_rowId].taskValue] = '0'
          }
        } else {
          let sumFloor = Math.floor(sumProcessValue/data[rowId].length)
          if (sumFloor>0&&sumFloor<10)
            sumFloor = sumFloor/100
          else if (sumFloor>=10&&sumFloor<100)
            sumFloor = (sumFloor/100)+1
          else if (sumFloor>=100)
            sumFloor = '2'
          
          sumFloor = sumFloor.toString()
          workData[data[rowId][_rowId].taskValue] = sumFloor
        }
      }
    } else {
      workData[data[rowId].taskValue] = data[rowId].taskStatus
    }
    this.setState({workData:workData})
    this.refs.jcbTable.getWrappedInstance().loadData([workData],workState)
  }

  saveTask(assignIndex, data, _assignIndex) {
    let {messages} = this.props
    let assignData = ''
    if (Array.isArray(data[assignIndex]))
      assignData = data[assignIndex][_assignIndex]
    else
      assignData = data[assignIndex]
    
    let { workNo } = this.state
    let startDate = assignData.startTime.date !== '' ? momentHelper.convertThaiToWorldYear(assignData.startTime.date) : ''
    let endDate = assignData.finishTime.date !== '' ? momentHelper.convertThaiToWorldYear(assignData.finishTime.date) : ''

    let meta = {
      work_no: workNo,
      contractor_id: assignData.assignTask.person.contractor_id !== undefined ? assignData.assignTask.person.contractor_id : '',
      employee_id: assignData.assignTask.person.employee_id !== undefined ? assignData.assignTask.person.employee_id : "",
      leader_id: assignData.assignTask.leader.employee_id !== undefined ? assignData.assignTask.leader.employee_id : "",
      total_cost: assignData.wageAmount, bf_work_damage_id: 0,
      remark:assignData.remark
    }
    let tasklist = [{
      taskName: assignData.taskName, taskValue: assignData.taskValue, taskStatus: assignData.taskStatus,
      startDate: startDate, startTime: assignData.startTime.time,
      endDate: endDate, endTime: assignData.finishTime.time, duration: (assignData.duration==null||assignData.duration==undefined?'':assignData.duration)
    }]
    let postData = { meta: meta, tasklist: tasklist }
    WorkdocStore.saveWorkdocFixingTask(assignData.bf_task_id, postData,(result)=>{
      this.updateWorkData(data,assignIndex,_assignIndex)
      this.onAfterSave(result,data,assignIndex,_assignIndex)
    },()=>{
      this._notificationSystem.addNotification({
        title: messages['Notice'],
        message: messages['Failed Save Work'] + ' ' + workNo + ' ' + messages['Failed'],
        level: 'error',
        position: 'tc'
      });
    })
  }

  getStatusOption() {
    let {messages} = this.props
    const label0 = (<div><FontAwesome name='check-circle' style={{color:'grey'}} /> {messages['Waiting Start']}</div>)
    const label2 = (<div><FontAwesome name='check-circle' style={{color:'blue'}} /> <span className='text' style={{color:'#fff'}}>{messages['Done']}</span></div>)
    const label3 = (<div><FontAwesome name='check-circle' style={{color:'red'}} /> {messages['Pause']}</div>)
    const label10 = (<div><FontAwesome name='check-circle' style={{color:'orange'}} /> {messages['Fixing']} 0%</div>)
    const label12 = (<div><FontAwesome name='check-circle' style={{color:'orange'}} /> {messages['Fixing']} 20%</div>)
    const label14 = (<div><FontAwesome name='check-circle' style={{color:'orange'}} /> {messages['Fixing']} 40%</div>)
    const label16 = (<div><FontAwesome name='check-circle' style={{color:'orange'}} /> {messages['Fixing']} 60%</div>)
    const label18 = (<div><FontAwesome name='check-circle' style={{color:'orange'}} /> {messages['Fixing']} 80%</div>)
    return [
      { label: messages['Not Defined'], value: '-1' },
      { label: messages['No Item'], value: '-2' },
      { label: label0, value: '0' },
      { label: label10, value: '1.00' },
      { label: label12, value: '1.20' },
      { label: label14, value: '1.40' },
      { label: label16, value: '1.60' },
      { label: label18, value: '1.80' },
      { label: label2, value: '2' },
      { label: label3, value: '3' },
    ]
  }

  renderTimePicker(rowIndex,value,k,titleId,taskStatus,_rowIndex) {
    return (
      <CkTimePicker
        disabled={taskStatus==='-2'}
        value={value}
        onTimeSaved={this.onTimeChange.bind(this, k, rowIndex, _rowIndex)}
      />
    )
  }

  renderDateTimeTD(rowIndex, item, k, titleId, _rowIndex) {
    let {messages} = this.props
    if (k === 'startTime') {
      return (
        <td
          key={titleId}
          style={{ padding: '0' }}>
          <div style={{ display: 'table-row' }} >
            <div className='bt-td-left'>
              {messages['Date']}
            </div>
            <div className='bt-td-right text-center' style={{ width: '100%' }}>
              {this.renderDatePicker(rowIndex,item.startTime.date,k,item.taskStatus,_rowIndex)}
            </div>
          </div>
          <div style={{ display: 'table-row' }} >
            <div
              className='bt-td-left'
              style={{ borderBottom: '0' }}
            >
              {messages['Time']}
            </div>
            <div
              className='bt-td-right text-center'
              style={{ width: '100%', borderBottom: '0' }}>
              {this.renderTimePicker(rowIndex,item.startTime.time,k,titleId,item.taskStatus,_rowIndex)}
            </div>
          </div>
        </td>
      )
    }
    return (
      <td
        key={titleId}
        style={{ padding: '0' }}
      >
        <div style={{ display: 'table-row' }} >
          <div className='bt-td-right text-center' style={{ width: '1%' }}>
            {this.renderDatePicker(rowIndex, item.finishTime.date, k,item.taskStatus,_rowIndex)}
          </div>
        </div>
        <div style={{ display: 'table-row' }} >
          <div
            className='bt-td-right text-center'
            style={{ width: '1%', borderBottom: '0' }}>
            {this.renderTimePicker(rowIndex, item.finishTime.time, k, titleId,item.taskStatus,_rowIndex)}
          </div>
        </div>
      </td>
    )
  }

  renderNormalTD(rid, item, k, titleId, _rid) {
    let {data} = this.state
    const rowSpan = (Array.isArray(data[rid])?data[rid].length:1)
    if ((Array.isArray(data[rid])&&_rid==0)||(!Array.isArray(data[rid]))) {
      return(
        <td rowSpan={rowSpan} key={titleId} className='fit text-center'>
          {item[k]}
        </td>
      )
    } else {
      return('')
    } 
  }

  onAddTechnicianNameClick(rid) {
    let {data} = this.state
    let rowData = []
    let newInitData = JSON.parse(JSON.stringify(mockData))
    if (Array.isArray(data[rid])) {
      newInitData.taskName = data[rid][data[rid].length-data[rid].length].taskName
      newInitData.taskValue = data[rid][data[rid].length-data[rid].length].taskValue
    } else {
      newInitData.taskName = data[rid].taskName
      newInitData.taskValue = data[rid].taskValue
    }  

    if (Array.isArray(data[rid]))
      rowData = data[rid]
    else
      rowData.push(data[rid])
    
    rowData.push(newInitData) 
    data[rid] = rowData
    this.setState({data:data})
  }

  onDelTechnicianNameClick(rid,_rid) {
      let {data} = this.state
      let bf_task_id = (Array.isArray(data[rid])?data[rid][_rid].bf_task_id:data[rid].bf_task_id)
      if (bf_task_id==''||bf_task_id==undefined||bf_task_id==null) {
        if (Array.isArray(data[rid])) {
          data[rid].splice(_rid, 1) 
          if (data[rid].length<2) {
            data = data.map((item,index)=>{
              if (index==rid)
                return item[item.length-1]
              else 
                return item  
            })
          }
        } else {
          data.splice(rid, 1)
        }
        this.setState({ data: data, showAssign: false, assignIndex: -1, _assignIndex: -1 })
      } else {
        this.setState({showTaskDelete:true,assignIndex:rid,_assignIndex:_rid})
      } 
  }

  onConfirmDelTechnicianNameClick() {
    let {data,assignIndex,_assignIndex} = this.state
    let {workState} = this.props
    let bf_task_id = (Array.isArray(data[assignIndex])?data[assignIndex][_assignIndex].bf_task_id:data[assignIndex].bf_task_id)
    WorkdocStore.delWorkdocFixingTask(bf_task_id,(result)=>{
        if (result.status=='OK') {
          if (Array.isArray(data[assignIndex])) {
            data[assignIndex].splice(_assignIndex, 1) 
            if (data[assignIndex].length<2) {
              data = data.map((item,index)=>{
                if (index==assignIndex)
                  return item[item.length-1]
                else 
                  return item  
              })
            }
          } else {
            data.splice(assignIndex, 1)
          }
          this.setState({ data: data, assignIndex: -1, _assignIndex: -1, showTaskDelete: false, showAssign:false })
          let checkTaskValue = data.map((item,index)=>{
            if (Array.isArray(item))
              return item[item.length-1].taskValue
            else  
              return item.taskValue
          })
          let newResult = this.onSetInitData(data,checkTaskValue,workState)
          this.updateWorkData(newResult,assignIndex,_assignIndex)
          this.setState({data:newResult})
        }  
    },()=>{
        this.setState({ data: data, assignIndex: -1, _assignIndex: -1, showTaskDelete: false, showAssign:false })
    })
  }

  onHideConfirmDelTechnicianNameClick() {
    let {showAssign} = this.state
    if (showAssign)
      this.setState({ showTaskDelete: false })
    else
      this.setState({ showTaskDelete: false, assignIndex: -1, _assignIndex: -1 })   
  }

  renderButtonTD(rid, item, k, titleId, titleBtn, _rid) {
    let {data} = this.state
    if (item[k] !== undefined && item[k] !== "" && item[k] !== "0") {
      titleBtn = item[k]==' '?this.props.messages['Anonymous']:item[k]
    }
    let onClick = item.taskStatus==='-2'?undefined:this.onTechnicianEdit.bind(this, rid, _rid)
    return(
      <td key={titleId} className='fit text-center'>
        <Button bsStyle='link' onClick={onClick} disabled={item.taskStatus==='-2'}>
          <FontAwesome name='pencil' />{' '} {titleBtn}
        </Button>
        {(k=='technicianName'&&item.taskStatus!='-2'&&Array.isArray(data[rid])&&_rid==0)||(k=='technicianName'&&item.taskStatus!='-2'&&!Array.isArray(data[rid]))
        ?<div className='text-right' style={{display:(Array.isArray(data[rid])&&_rid>0?'none':''),position:'relative',cursor:'pointer'}}><FontAwesome style={{position:'absolute',bottom:'-35px',right:(item.bf_task_id!=''&&item.bf_task_id!=undefined&&item.bf_task_id!=null?'30px':'0')}} onClick={this.onAddTechnicianNameClick.bind(this,rid)} className='color-green' name='plus' /> <FontAwesome style={{position:'absolute',bottom:'-35px',right:'0',display:(item.bf_task_id!=''&&item.bf_task_id!=undefined&&item.bf_task_id!=null?'':'none')}} onClick={this.onDelTechnicianNameClick.bind(this,rid,_rid)} className='color-red' name='minus' /></div>
        :k=='technicianName'&&item.taskStatus!='-2'&&Array.isArray(data[rid])&&_rid>0
        ?<div className='text-right' style={{position:'relative',cursor:'pointer'}}><FontAwesome style={{position:'absolute',bottom:'-35px',right:'0'}} onClick={this.onDelTechnicianNameClick.bind(this,rid,_rid)} className='color-red' name='minus' /></div>
        :''}
      </td>
    )
  }

  renderRemarkTD(rid, item, k, titleId, titleBtn, _rid) {
    if (item[k] !== undefined && item[k] !== "" && item[k] !== "0") {
      titleBtn = item[k]
    }
    return (
      <td key={titleId} className='fit text-center'><Button bsStyle='link' onClick={this.onRowRemarkEdit.bind(this, rid, _rid)}>
        <FontAwesome name='pencil' />{' '} {titleBtn}</Button></td>
    )
  }

  renderStatus(rid, item, k, titleId, _rid) {
    let bgColor = '';
    if (item[k][0] === '1') {
      bgColor = 'orange'
    } else if (item[k] === '2') {
      bgColor = '#0073b7'
    } else if (item[k] === '3') {
      bgColor = '#dd4b39'
    }
    let {messages} = this.props
    return (
      <td key={titleId} className='fit text-center'>
        <Select placeholder={messages['Select']} clearable={false}
          style={{ minWidth: '90px', background: bgColor }}
          value={item[k]}
          options={this.getStatusOption()}
          onChange={this.onSelectChange.bind(this, rid, _rid)}
        />
      </td>
    )
  }

  renderRowBg(taskStatus) {
    if (taskStatus === '4' || taskStatus==='-2') {
      return 'bg-gray-light'
    } else {
      return ''
    }
  }

  renderDuration(rid, item, k, titleId) {
    let textTD = ''
    // if (item[k] !== '' && item[k] > 0)
    //   textTD = item[k] + ' ' + this.props.messages['Day']
    // else {
    //   textTD = this.props.messages['Unknown']
    // }
    textTD = item['man_hour'] + ' ' + item['man_hour_unit']
    return (<td key={titleId} className='fit text-center'>{textTD}</td>)
  }

  renderRows() {
    let {messages} = this.props
    if (this.state.data.length === 0) return null
    return this.state.data.map((item, rid) => { 
      if (Array.isArray(item)) {
        return(
          item.map((_item,_rid)=>{
            const tds =
              Object.keys(this.headerTitles).map((k, titleId) =>
                (
                  ['startTime', 'finishTime'].includes(k)
                    ? this.renderDateTimeTD(rid, _item, k, titleId, _rid)
                    : (k == 'technicianName')
                      ? this.renderButtonTD(rid, _item, k, titleId, messages['Edit Technician'], _rid)
                      : (k == 'wageAmount')
                        ? this.renderButtonTD(rid, _item, k, titleId, messages['Edit Price'], _rid)
                        : (k == 'inspector')
                          ? this.renderButtonTD(rid, _item, k, titleId, messages['Edit Inspector'], _rid)
                          : (k == 'remark')
                          ? this.renderRemarkTD(rid, _item, k, titleId, messages['Edit Remark'], _rid)
                          : (k == 'taskStatus')
                            ? this.renderStatus(rid, _item, k, titleId, _rid)
                            : (k == 'duration')
                              ? this.renderDuration(rid, _item, k, titleId)
                              : this.renderNormalTD(rid, _item, k, titleId, _rid)
                ))

            return (
              <tr key={'s-'+_rid} className={this.renderRowBg(_item.taskStatus)}>{tds}</tr>
            )
          })
        )
      } else {
        const tds =
          Object.keys(this.headerTitles).map((k, titleId) =>
            (
              ['startTime', 'finishTime'].includes(k)
                ? this.renderDateTimeTD(rid, item, k, titleId)
                : (k == 'technicianName')
                  ? this.renderButtonTD(rid, item, k, titleId, messages['Edit Technician'])
                  : (k == 'wageAmount')
                    ? this.renderButtonTD(rid, item, k, titleId, messages['Edit Price'])
                    : (k == 'inspector')
                      ? this.renderButtonTD(rid, item, k, titleId, messages['Edit Inspector'])
                      : (k == 'remark')
                      ? this.renderRemarkTD(rid, item, k, titleId, messages['Edit Remark'])
                      : (k == 'taskStatus')
                        ? this.renderStatus(rid, item, k, titleId)
                        : (k == 'duration')
                          ? this.renderDuration(rid, item, k, titleId)
                          : this.renderNormalTD(rid, item, k, titleId)
            ))

        return (
          <tr key={rid} className={this.renderRowBg(item.taskStatus)}>{tds}</tr>
        )
      }    
    })
  }

  renderTable() {
    let { workData } = this.state
    let {messages} = this.props
    return (
      <div>
        <div className='table-responsive'>
          <table className='table table-hover table-bordered-solid'>
            {this.renderHeader()}
            <tbody>
              {this.renderRows()}
            </tbody>
          </table>
        </div>
        <Row>
          <Col md={6}>
            <FormGroup
              controlId="formBasicText"
            >
              <ControlLabel>** {messages['Remark']}</ControlLabel>
              <FormControl
                componentClass="textarea"
                placeholder=""
                value={
                  workData !== null
                    ? workData.textState
                    : ''}
                onChange={this.onRemarkChange.bind(this)}
                onBlur={this.onRemarkBlur.bind(this)}
              />
              <FormControl.Feedback />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ButtonToolbar>
              <Button bsStyle='primary' onClick={this.onRemarkSave.bind(this)}><FontAwesome name='save' />{' '}{messages['Save Remark']}</Button>
              <Button onClick={this.onRemarkClear.bind(this)}><FontAwesome name='eraser' />{' '}{messages['Delete']}</Button>
            </ButtonToolbar>
          </Col>
        </Row>
      </div>
    )
  }

  render() {
    let titleTask = ''
    let { showAssign, loading } = this.state
    let {messages} = this.props
    return (
      <Box loading={loading}>
        <Box.Header  className='text-center'>
          <Box.Title>
                          
          </Box.Title> 
          <Box.Tools>
            <Button className="btn bg-maroon" onClick={this.onPrintClick.bind(this)}>
              <FontAwesome name="print" />&nbsp;{messages['Print Document']}
            </Button>
          </Box.Tools>
        </Box.Header>
        <Box.Body>
          <JobControlBoardTable ref='jcbTable' 
          jobStyle={this.props.jobStyle}
          jobState={this.props.jobState}
          showSearch={false}/>
          {this.renderTable()}

          <WorkJobAssignTaskModal ref='taskModal' show={showAssign} title={titleTask}
            showTask={false}
            showLeader={true}
            onDelete={this.onAssignTaskDelete.bind(this)}
            onSave={this.onAssignTaskSave.bind(this)}
            onHide={() => { this.setState({ showAssign: false, assignIndex: -1, _assignIndex: -1 }) }} />
          <TextFieldModal ref='rowRemarkModal' 
          confirmTitle={messages['Save']}
          onConfirm={this.onRowRemarkSave.bind(this)}
          />
          <ConfirmPopup
            show={this.state.showTaskDelete}
            message={messages['Want To Delete This Item']}
            onConfirm={this.onConfirmDelTechnicianNameClick.bind(this)}
            onHide={this.onHideConfirmDelTechnicianNameClick.bind(this)}
          />
          <NotificationSystem ref="notificationSystem" />
        </Box.Body>
        <Box.Footer>
        </Box.Footer>
        <IframeModal ref='iframePrint' title={messages['Print Document']} />
      </Box>
    )
  }
}

export default WorkJobTimeTable = connect(
  (state) => ({messages: state.message.view.workdoc.jobcontrol.WorkJobTimeTable}),null,null,{withRef:true}
)(WorkJobTimeTable);


// WEBPACK FOOTER //
// ./src/view/workdoc/jobcontrol/WorkJobTimeTable.js